// extracted by mini-css-extract-plugin
module.exports = {"cardHolder":"StudentRequests_cardHolder__2ICrQ"};